module.exports = __webpack_public_path__ + "img/43582a0.jpg";